module.exports = __webpack_public_path__ + "static/aspersores-5eea24568069b547522fd4d148c0d77b.jpg";